import React from 'react';
import logo from '../logo.svg';
import '../App.css';

export const NotFound = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={'/img/logo_cah.jpg'} className="App-logo" alt="logo" />
      </header>
    </div>
  );
};
